import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
  	routes:[
      { path: '*', component: require(page+'error-404.vue').default, meta:{title:"Error"} },

	    { path: '/', name: 'homePage', component: require(page+'home.vue').default },

      { path: '/empleos', component: require(page+'job-offers/jobs-results.vue').default, meta:{title:"Empleos disponibles"} },
      { path: '/empleos/:id', component: require(page+'job-offers/job-description.vue').default, meta:{title:"Vacante"} },
      { path: '/empresas', component: require(page+'job-offers/companies-results.vue').default, meta:{title:"Empresas contratando"} },
      { path: '/empresas/:id', component: require(page+'job-offers/company-description.vue').default, meta:{title:"Perfil Empresarial"} },
      { path: '/empresas/empleos/:id', component: require(page+'job-offers/company-jobs.vue').default, meta:{title:"Vacantes"} },

      { path: '/candidatos', component: require(page+'candidates/index.vue').default, meta:{title:"Candidatos"} },
      { path: '/perfil-candidato/:id', component: require(page+'candidates/candidate-profile.vue').default, meta:{title:"Perfil del candidato"} },

      { path: '/cuenta-usuario', component: require(page+'account/user/index.vue').default, meta:{ title: 'Cuenta Usuario' },
  			children: [
  			{
  				path: '/', name: 'userAccIndex',
  				component: require(page+'account/user/panel.vue').default,
  				meta:{ title: 'Panel | Cuenta Usuario' }
  			},
        {
  				path: 'foto', name: 'userAccImagePhoto',
  				component: require(page+'account/user/image-photo.vue').default,
  				meta:{ title: 'Foto | Cuenta Usuario' }
  			},
        {
  				path: 'imagen-de-cabecera', name: 'userAccBanner',
  				component: require(page+'account/user/image-banner.vue').default,
  				meta:{ title: 'Imagen de cabecera | Cuenta Usuario' }
  			},
        {
  				path: 'mi-perfil', name: 'userAccProfile',
  				component: require(page+'account/user/user-profile.vue').default,
  				meta:{ title: 'Mi perfil | Cuenta Usuario' }
  			},
        {
  				path: 'mi-curriculum', name: 'userAccCV',
  				component: require(page+'account/user/my-cv.vue').default,
  				meta:{ title: 'Mi curriculum | Cuenta Usuario' }
  			},
        {
  				path: 'vacantes-aplicadas', name: 'userAccAppliedVacancies',
  				component: require(page+'account/user/applied-vacancies.vue').default,
  				meta:{ title: 'Vacantes Aplicadas | Cuenta Usuario' }
  			},
        {
  				path: 'calificaciones', name: 'userAccComments',
  				component: require(page+'account/user/comments.vue').default,
  				meta:{ title: 'Calificaciones | Cuenta Usuario' }
  			},
        {
          path: 'calificacionesempresas', name: 'userAccCommentstocompanies',
          component: require(page+'account/user/commentstocompanies.vue').default,
          meta:{ title: 'Calificaciones a empresas | Cuenta Usuario' }
        },

        {
  				path: 'mensajes', name: 'userAccMessages',
  				component: require(page+'account/user/messages.vue').default,
  				meta:{ title: 'Mensajes | Cuenta Usuario' }
  			},
        {
          path: 'vacantes-favoritas', name: 'userVacants',
          component: require(page+'account/user/favorites-vacancies.vue').default,
          meta:{ title: 'Vacantes favoritas | Cuenta Usuario' }
        },

        {
  				path: 'seguridad', name: 'userAccSecurity',
  				component: require(page+'account/user/security.vue').default,
  				meta:{ title: 'Seguridad | Cuenta Usuario' }
  			},
        ]
      },

      { path: '/cuenta-empresa', component: require(page+'account/company/index.vue').default, meta:{ title: 'Cuenta Empresa' },
  			children: [
  			{
  				path: '/', name: 'compAccIndex',
  				component: require(page+'account/company/panel.vue').default,
  				meta:{ title: 'Panel | Cuenta Empresa' }
  			},
        {
  				path: 'logo', name: 'compAccImageLogo',
  				component: require(page+'account/company/image-logo.vue').default,
  				meta:{ title: 'Logo | Cuenta Empresa' }
  			},
        {
  				path: 'imagen-de-cabecera', name: 'compAccBanner',
  				component: require(page+'account/company/image-banner.vue').default,
  				meta:{ title: 'Imagen de cabecera | Cuenta Empresa' }
  			},
        {
  				path: 'perfil-de-empresa', name: 'compAccProfile',
  				component: require(page+'account/company/company-profile.vue').default,
  				meta:{ title: 'Perfil de Empresa | Cuenta Empresa' }
  			},
        {
  				path: 'planes', name: 'compAccPlans',
  				component: require(page+'account/company/plans.vue').default,
  				meta:{ title: 'Perfil de Empresa | Planes' }
  			},
        {
          path: 'publicar-vacante', name: 'compAccPostVacancy',
          component: require(page+'account/company/post-vacancy.vue').default,
          meta:{ title: 'Publicar nueva vacante | Cuenta Empresa' }
        },
        {
  				path: 'publicar-vacante/:id', name: 'compAccPostVacancy',
  				component: require(page+'account/company/post-vacancy.vue').default,
  				meta:{ title: 'Publicar nueva vacante | Cuenta Empresa' }
  			},
        {
  				path: 'editar-vacantes', name: 'compAccEditVacancies',
  				component: require(page+'account/company/edit-vacancies.vue').default,
  				meta:{ title: 'Editar Vacantes | Cuenta Empresa' }
  			},
        /*{
  				path: 'editar-vacante/:id', name: 'compAccEditVacancy',
  				component: require(page+'account/company/edit-vacancy.vue').default,
  				meta:{ title: 'Editar Vacante | Cuenta Empresa' }
  			},*/
        {
  				path: 'candidatos/:id?', name: 'compAccCandidates',
  				component: require(page+'account/company/candidates.vue').default,
  				meta:{ title: 'Candidatos aplicaron | Cuenta Empresa' }
  			},
        {
          path: 'todos-los-candidatos/:id?', name: 'AllCandidates',
          component: require(page+'account/company/allcandidates.vue').default,
          meta:{ title: 'Todos lo candidatos | Cuenta Empresa' }
        },
        {
  				path: 'perfiles-guardados', name: 'compAccSavedProfiles',
  				component: require(page+'account/company/saved-profiles.vue').default,
  				meta:{ title: 'Perfiles guardados | Cuenta Empresa' }
  			},
        {
  				path: 'calificaciones', name: 'compAccComments',
  				component: require(page+'account/company/comments.vue').default,
  				meta:{ title: 'Calificaciones a mi empresa | Cuenta Empresa' }
  			},
        {
          path: 'calificaciones_candidatos', name: 'compAccCommentsCandidates',
          component: require(page+'account/company/commentscandidates.vue').default,
          meta:{ title: 'Calificaciones a candidatos | Cuenta Empresa' }
        },

        {
  				path: 'mensajes', name: 'compAccMessages',
  				component: require(page+'account/company/messages.vue').default,
  				meta:{ title: 'Mensajes | Cuenta Empresa' }
  			},
        {
  				path: 'seguridad', name: 'compAccSecurity',
  				component: require(page+'account/company/security.vue').default,
  				meta:{ title: 'Seguridad | Cuenta Empresa' }
  			},
        ]
      },

	    // { path: '/checkout', component: require(page+'checkout.vue').default, meta:{title:"Checkout"}},
	  ]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},500);
	}


});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter,
	{ defTitle: "JOBUSCO", filter: (title)=>{ return title+" - JOBUSCO"; } }
);

// export {routes};
export default MyRouter;
